import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';
import { registerServiceWorker } from "@/pwa/registerServiceWorker.js";

ReactDOM.createRoot(document.getElementById('root')).render(
	<App />
);

registerServiceWorker();

if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    const reloaded = sessionStorage.getItem("page_chunk_reload_attempt");
    if (!reloaded) {
      sessionStorage.setItem("page_chunk_reload_attempt", "true");
      window.location.reload();
    }
  });
}

if (import.meta.env.DEV) {
	const reportHorizontalOverflow = () => {
		window.setTimeout(() => {
			const viewportWidth = document.documentElement.clientWidth;

			document.querySelectorAll("*").forEach((element) => {
				const rect = element.getBoundingClientRect();

				if (rect.right > viewportWidth + 1 || rect.left < -1) {
					console.warn("Horizontal overflow:", element, rect);
				}
			});
		}, 1000);
	};

	reportHorizontalOverflow();
	window.addEventListener("resize", reportHorizontalOverflow);
}
